import styled from 'styled-components'
import { theme } from '../../styles/theme'

export const Container = styled.div`
  margin: 25px 0;
  @media (min-width: 768px) {
    width: 30%;
  }
`

export const Content = styled.div`
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 160%;
  letter-spacing: 0.2px;
  li {
    margin-left: 20px;
  }
  max-height: 200px;
  overflow-y: auto;
  margin-top: 10px;
`

export const HeaderCard = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: ${theme.colors.system};
`

export const Span = styled.span`
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  color: ${theme.colors.green2};
`

export const Span2 = styled.span`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  color: ${theme.colors.gray700};
`

export const EditDiv = styled.div`
  cursor: pointer;
  img {
    margin-right: 5px;
  }
  span {
    color: ${theme.colors.erro};
  }
`
